import { AppInsightsProvider } from "Infrastructure/repositories/appInsights/AppInsights";
import { IdleProvider } from "application/contexts/idle/IdleContext";
import NewPrinterProvider from "application/contexts/printer/PrinterProvider";
import { ThemeProvider } from "application/contexts/theme/ThemeContext";
import OrderProvider, {
  IOrderProviderRef,
} from "modules/order/presentation/OrderProvider";
import React, { FC, memo, useRef } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "routes/Routes";
import "./App.css";
import { AuthProvider } from "./application/contexts/auth/AuthContext";
import { CardReaderProvider } from "./application/contexts/cardReader/CardReaderContext";
import {
  KioskConsumer,
  KioskProvider,
} from "./application/contexts/kiosk/KioskContext";
import { SessionProvider } from "./application/contexts/session/SessionContext";
import { UIProvider } from "./application/contexts/ui/UIContext";
import "./cores.css";

const App: FC = memo(() => {
  const orderProvider = useRef<IOrderProviderRef>(null);

  return (
    <div className="App">
      <UIProvider>
        <BrowserRouter>
          <AuthProvider>
            <KioskProvider>
              <KioskConsumer>
                {({ kiosk }) => (
                  <AppInsightsProvider kiosk={kiosk}>
                    <IdleProvider kiosk={kiosk}>
                      <ThemeProvider>
                        <SessionProvider>
                          <CardReaderProvider>
                            <NewPrinterProvider kiosk={kiosk} />
                            <OrderProvider ref={orderProvider} />
                            <Routes orderProvider={orderProvider} />
                          </CardReaderProvider>
                        </SessionProvider>
                      </ThemeProvider>
                    </IdleProvider>
                  </AppInsightsProvider>
                )}
              </KioskConsumer>
            </KioskProvider>
          </AuthProvider>
        </BrowserRouter>
      </UIProvider>
    </div>
  );
});

export default App;
